<mat-toolbar class="topbar horizontal-topbar">
  <div class="container d-flex align-items-center">
    <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex d-lg-none me-3" matTooltip="Abrir menú">
      <mat-icon>menu</mat-icon>
    </button>
    
    <div class="d-none d-sm-flex">
      <app-branding></app-branding>
    </div>

    @if(userCompanies && userCompanies.length === 1) {
    <div>
      <div class="d-flex align-items-center">
        @if (selectedCompany?.logo) {
        <img [src]="selectedCompany.logo" alt="logo" class="company-logo me-4">
        }
        <span class="f-s-14 mat-body-1">{{ userCompanies[0].nombre }}</span>
      </div>
    </div>
    }

    @if(userCompanies && userCompanies.length > 1) {
    <div class="m-l-auto d-flex align-items-center justify-content-center">
      <div class="d-flex align-items-center">
        @if (selectedCompany?.logo) {
        <img [src]="selectedCompany.logo" alt="logo" class="company-logo me-4">
        }
        <span class="me-2">{{ selectedCompany?.nombre || 'Seleccionar Cliente' }}</span>
      </div>
      <button mat-icon-button [matMenuTriggerFor]="companyMenu" class="ms-2" matTooltip="Cambiar Cliente">
        <mat-icon>swap_horiz</mat-icon>
      </button>
    </div>
    }

    <span class="flex-1-auto"></span>

    <div [class.search-expanded]="isSearchExpanded" class="search-div">
      <mat-chip-grid #chipGrid aria-label="Términos de búsqueda">
        <mat-chip-row *ngFor="let param of searchParams" (removed)="removeSearchParam(param)" [removable]="true">
          {{param}}
          <button matChipRemove [attr.aria-label]="'Remover ' + param">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="[ENTER]"
          placeholder="Agregar término de búsqueda..." [formControl]="searchControl" class="search-input"
          (focus)="isSearchExpanded = true" (keydown.enter)="$event.preventDefault(); performSearch()">
      </mat-chip-grid>
      <button mat-icon-button class="search-button" [matTooltip]="searchParams.length ? 'Limpiar búsqueda' : 'Buscar'"
        [color]="searchParams.length ? 'warn' : 'primary'"
        (click)="searchParams.length ? clearSearch() : performSearch()">
        @if (searchParams.length) {
        <mat-icon>close</mat-icon>
        } @else {
        <mat-icon>search</mat-icon>
        }
      </button>
    </div>

    <button mat-fab extended color="inherit" [matMenuTriggerFor]="profileMenu" aria-label="Perfil">
      <div class="d-flex align-items-center">
        <div class="profile-initials-circle" style="background-color: #1e88e5; color: white;">
          {{ getUserInitials() }}
        </div>
        <div class="m-l-16 text-left d-none d-lg-flex">
          <div>
            <h5 class="f-s-16">{{ userName }}</h5>
            <span class="f-s-14 mat-body-1">{{ userRole }}</span>
          </div>
        </div>
      </div>
    </button>

    <mat-menu #profileMenu="matMenu" xPosition="before" class="topbar-dd cardWithShadow">
      <ng-scrollbar class="position-relative" style="height: 220px;">
        <div class="p-x-10 p-y-16">
          <div class="d-flex align-items-center p-y-10 b-b-1 b-t-1 m-t-5">
            <div class="profile-initials-circle-large" style="background-color: #1e88e5; color: white;">
              {{ getUserInitials() }}
            </div>
            <div class="m-l-16">
              <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">{{ userName }}</h6>
              <span class="f-s-14 mat-body-1 d-block m-b-4">{{ userRole }}</span>
              <span class="d-flex align-items-center">
                <i-tabler name="mail" class="icon-15 m-r-4"></i-tabler>
                {{ userEmail }}
              </span>
            </div>
          </div>

          <div class="p-y-5 m-t-10">
            <button mat-flat-button color="accent" class="w-100 m-b-12" (click)="openChangePasswordDialog()">
              <mat-icon class="m-r-8">lock</mat-icon>
              Cambiar Contraseña
            </button>
            <button (click)="logout()" mat-flat-button color="primary" class="w-100 m-t-5">
              Salir
            </button>
          </div>
        </div>
      </ng-scrollbar>
    </mat-menu>
    <button *ngIf="false" mat-icon-button [matBadge]="(showBadge$ | async) ? '1' : '0'" [matBadgeHidden]="!(showBadge$ | async)"
      matBadgeColor="warn" (mousedown)="$event.preventDefault()" (click)="openChangelog()">
      <mat-icon>update</mat-icon>
    </button>
    <mat-menu #companyMenu="matMenu">
      @for (company of userCompanies; track company.id) {
      <button mat-menu-item (click)="onCompanySelect(company)" [class.active]="company.id === selectedCompany?.id"
        class="d-flex align-items-center" style="padding: 16px 24px;">
        <div class="d-flex align-items-center">
          @if (company.logo) {
          <img [src]="company.logo" alt="logo"
            style="margin-right: 16px; width: 48px; height: 48px; object-fit: contain; border: 1px solid #eee;">
          } @else {
          <div
            style="margin-right: 16px; width: 48px; height: 48px; border: 1px solid #eee; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="font-size: 32px; opacity: 0.7;">business</mat-icon>
          </div>
          }
          <div class="ms-4">
            <span style="font-size: 14px; color: rgba(0,0,0,0.87);">{{company.nombre}}</span>
          </div>
        </div>

      </button>
      }
    </mat-menu>
  </div>
</mat-toolbar>